import React from 'react';

import { TableComponent } from 'commons/components/Table';
import { STOProcessedItem } from 'commons/types';

import { STOPickSummaryPageStyle as S } from '../STOPickSummaryPage.style';

import { summaryTableConfig } from './configs';

interface ISTOBinListProps {
  pickActual: STOProcessedItem[];
}

export const STOPickBinList: React.FC<ISTOBinListProps> = ({ pickActual }) => {
  return (
    <S.ItemContentWrapper container>
      <TableComponent
        data={pickActual || []}
        config={summaryTableConfig}
        additionalTableConfig={{ bodyFontSize: '12px' }}
      />
    </S.ItemContentWrapper>
  );
};
